<style lang="scss" scoped>
  .developers-block {
    width: 100%;
    max-width: 1400px;
    @include margin-x(auto);
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 60%;
    background-position: 0 0;
    position: relative;

    @include media(max, lg) {
      background-size: 65% auto;
      background-position: 0 40%;
      margin-bottom: 20px;
    }

    @include media(max, md) {
      background-size: 750px auto;
      background-position: 50% 50%;
    }

    .content {
      z-index: 10;
      height: 600px;
      position: relative;
      @include margin-x(auto);
      width: map_get($container, lg);
      padding-left: 512px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      [dir=rtl] & {
        padding-left: 0;
        padding-right: 512px;

        @include media(max, md) {
          @include padding-x($gutter/2);
        }
      }

      @include media(max, lg) {
        width: map_get($container, md);
        height: 380px;
        padding-left: 350px;
      }

      @include media(max, md) {
        width: 100%;
        @include padding-x($gutter/2);
        height: auto;
        margin-top: 309px;
        max-width: 100%;
        text-align: center;
        position: relative;
        &:after{
          content: "";
          position: absolute;
          bottom: 0;
          z-index: -1;
          left: 0;
          right: 0;
          height: calc(100% + 155px);
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, #000000 100%);
        }
      }

      .text {
        margin-top: 22px;
        font-size: 18px;
        line-height: 1.6;
        color: rgba(white, .76);

        @include media(max, lg) {
          margin-top: 16px;
          font-size: 16px;
        }
      }

      .controls {
        margin-top: 32px;

        .button {
          text-align: center;

          @include media(max, md) {
            display: block;
          }
        }
      }
    }

    [dir=rtl] & {
      background-position-x: 120%;

      @include media(max, md) {
        background-size: 750px auto;
        background-position: 50% 50%;
      }
    }
  }
</style>

<template>
  <div class="developers-block" :style="{ backgroundImage: `url(${baseUrl}images/blocks/for-developers.png)` }">
    <div class="content">
      <div class="title_section">{{$t('title')}}</div>
      <div class="text" v-html="$t('text')"></div>
      <div class="controls">
        <btn
          variant="secondary"
          class="test fw-semi-bold"
          :href="devUrl">{{$t('more')}}</btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DevelopersBlock',
  i18n: {
    messages: {
      ru: {
        title: 'Разработчикам',
        text:
          'У вас есть собственная игра? Получите доступ к&nbsp;качественному трафику и стабильный источник дохода',
        more: 'Подробнее',
      },
      en: {
        title: 'Developers',
        text: 'Do you have your own game? Gain access to quality traffic and a stable source of income',
        more: 'Find out more',
      },
      de: {
        title: 'Entwickler',
        text: 'Du hast dein eigenes Spiel? Profitiere von qualitativ hochwertigem Datenverkehr und einer zuverlässigen',
        more: 'Mehr',
      },
      fr: {
        title: 'Développeurs',
        text:
          'Vous avez votre propre jeu? Obtenez du trafic de haute qualité et une source fiable de revenus',
        more: 'Plus',
      },
      es: {
        title: 'Desarrolladores',
        text:
          'Tienes un juego? Consigue una mayor afluencia y una fuente segura de ingresos',
        more: 'Más',
      },
      tr: {
        title: 'Geliştiriciler',
        text: 'Oyunun mu var? Yüksek trafik ve güvenilir bir gelir kaynağı edin',
        more: 'Daha fazla',
      },
      pl: {
        title: 'Twórcy',
        text:
          'Masz własną grę? Zdobądź wysokiej jakości ruch w Internecie i niezawodne źródło dochodów',
        more: 'Więcej',
      },
      ar: {
        title: 'المطوِّرون',
        text: 'هل تمتلك لعبتك الخاصة؟  تمتع بالوصول إلى حركة مرور ممتازة ومصدر دخل ثابت',
        more: 'اكتشاف المزيد',
      },
    },
  },
  computed: {
    devUrl() {
      return 'https://documentation.vkplay.ru/';
    },
  },
};

</script>
